import { HttpStatusCode } from "axios";
import { axiosClient } from "../../common/api/axios-client";

export const fetchMeetingDetails = async (user_email: string) => {
    try {
        const response = await axiosClient.get("/meeting_details", {
        params: { user_email },
        });
    
        if (response.status !== HttpStatusCode.Ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
        }
    
        return response.data;
    } catch (error) {
        console.error("Error fetching available slots:", error);
        throw error;
    }
}